// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8874) return "static/chunks/bbfbfb6c-a3e62ad28732be26.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9779 ? "d2d722bc" : chunkId) + "." + {"1097":"b52c6c2d95613291","6221":"63559d2439187b59","9779":"77309aab734d0f26"}[chunkId] + ".js";
};